<template>
      <main class="main">
        <loading-container :loading="loading" >
          <div class="worker">
            <div class="worker-header">
              <organization_header />
              <app-button class="worker-add" @click="add()">Добавить магазин</app-button>
            </div>
            <div class="worker-main">
              <table class="worker-table">
                <tr>
                  <th>ID<img src="@/assets/img/main/open.svg"></th>
                  <!--<th>Город</th>-->
                  <th>Город</th>
                  <th>Адрес</th>
                  <th>Вывеска</th>
                  <th>Площадь, м<sup>2</sup></th>
                  <th>Специализация</th>
                  <th>Телефон</th>
                  <th>Точка выдачи ИМ</th>
                  <th>Статус</th>
                  <th width="30px"></th>
                  <th style="text-align: center;">Активный</th>
                </tr>
                <tr v-for="(store, key) in stores" :key="store.id">
                  <td @click="view(store.id)">{{key+1}}</td>
                  <!--<td>Москва</td>-->
                  <td @click="view(store.id)">{{store.legal_address_city}}</td>
                  <td @click="view(store.id)">{{store.legal_address_street}}</td>
                  <td @click="view(store.id)">{{store.board}}</td>
                  <td @click="view(store.id)">{{store.area}}</td>
                  <td @click="view(store.id)">{{store.store_specialization != null ? store.store_specialization.name : ''}}</td>
                  <td @click="view(store.id)">{{store.phone}}</td>
                  <td @click="view(store.id)" :class="{'true':store.eshop}">{{store.eshop ? 'Да' : 'Нет'}}</td>
                  <td @click="view(store.id)" :class="{'true':store.active}">{{store.active ? 'Работает' : 'Не работает'}}</td>
                  <td class="action" @click="edit(store.id)">
                      <img class="hover_btn" src="@/assets/img/main/edit.svg" alt="" width="15px">
                  </td>
                  <td style="text-align: center;">
                    <div style="display: inline-block;">
                      <app-checkbox v-model="store.show" @change="toggleActive(store.id, store.show)" white table/>
                    </div>
                  </td>
                </tr>
                <!--<tr>
                  <td>3</td>
                  <td>Москва</td>
                  <td>ул.Нагатирская набер</td>
                  <td>Магазин</td>
                  <td>35 кв.м.</td>
                  <td>-</td>
                  <td>+79109295271</td>
                  <td>Нет</td>
                  <td class="true">Работает</td>

                </tr>-->
              </table>
            </div>
          </div>
        </loading-container>
      </main>
</template>

<script>

  import organization_header from "@/components/OrganizationHeader.vue"
  import LoadingContainer from "@/components/loading-container";
  import AppButton from "@/components/app-button";
  import AppCheckbox from "@/components/app-checkbox";

    export default {
        name: "edit",
        data: ()=>({
          stores: [],
          loading: true
        }),
        mounted() {
          this.getStores();
        },
        components: {
          AppButton,
          LoadingContainer,
          organization_header,
          AppCheckbox
        },
        methods: {
          getStores() {
            if (localStorage.getItem('token')) {
              this.loading = true;
              this.$http.post('/get-stores', {
                token: localStorage.getItem('token')
              }).then(({data}) => {
                if (data.stores) {
                  this.stores = data.stores;
                }
              })
              .catch((error) => {
                  console.log(error)
              })
              .finally(()=> this.loading = false)
            }
          },
          toggleActive(id, show) {
            this.$http.post('/toggle-active-store', {
              token: localStorage.getItem('token'),
              show: show ? 1 : 0,
              id: id
            }).then(({data}) => {
              if (data.success) {
                this.$toast.success(show ? 'Торговая точка успешно активирована!' : 'Торговая точка успешно деактивирована!');
              }
            })
            .catch((error) => {
                console.log(error)
            })
          },
          add() {
            this.$router.push({name: 'addStorePoint'});
          },
          edit(id) {
            this.$router.push({name: 'editStorePoint', params : {id}});
          },
          view(id) {
            this.$router.push({name: 'viewStorePoint', params : {id}});
          }
        }
    }
</script>

<style scoped lang="scss">
  .action {
    width: 35px;
    cursor: pointer;
    padding: 0 !important;

    img{
      display: block;
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }

  .worker {
    &-main{
      border-radius: 5px;
      box-shadow: 0px 0px 3px #E5E5EA;
      outline: hidden;
    }
    &-table {
      border-collapse: collapse;
      width: 100%;
      background: #fff;
      border: 1px #a3a3a3 solid;
      border-radius: 5px;
      tr {
        &:nth-child(even) {
          background: #F9F9FB;
        }
      }
      th, td {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        padding: 7px 14px;
        height: 40px;
        text-align: left;
        img{
          margin-right: -11px;
          margin-left: 2px;
        }
        &.true{
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 16px;
          color: #2CB181;        }
        &:not(:last-child) {
          border-right: 1px #a3a3a3 solid;
        }
      }
      th {
        color: #2D3137;
      }
      td{
        cursor: pointer;
      }
      tr {
        color: #7A818F;
      }
    }
    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      &-navigation{
        width: 60%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 8px 0 0;
        background-color: #FFFFFF;
        border-radius: 0px;
        button{
          height: 40px;
          border: none;
          outline: none;
          width: 100%;
          background-color: #FFFFFF;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #7A818F;
          cursor: pointer;
          padding: 0 15px;
          margin: 2px 0;
          border-radius: 0px;
        }
        .active{
          background: #EEF0F3;
          border-radius: 4px;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #2D3137;
          margin: 0 -5px;
        }
        hr{
          height: 20px;
          border: 1px solid #EEF0F3;
        }
      }
    }
    &-search {
      position: relative;
      width: 20%;
      display: flex;
      justify-content: flex-end;
      margin: 0 8px;

      > input {
        border: 1px solid #EEF0F3;
        box-sizing: border-box;
        border-radius: 4px;
        width: 100%;
        height: 40px;
        padding: 0 40px 0 15px;
        outline: none;
      }

      > img {
        position: absolute;
        right: 15px;
        bottom: 50%;
        transform: translateY(50%);
        width: 14px;
        height: 14px;
      }
    }
    &-add {
      width: 20%;
      margin: 0 0 0 8px;
    }
    &-action {
      display: flex;
      justify-content: space-between;
      align-items: center;
      button {
        height: 20px;
        border: none;
        background: none;
        cursor: pointer;
        outline: none;
        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
